<div [ngClass]="cardClasses">
  <header class="card__header" *ngIf="showHeader">
    <ng-content select="[go-card-header]"></ng-content>
  </header>
  <div class="card_content">
    <ng-content select="[go-card-content]"></ng-content>
  </div>
</div>
